import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { AppComponent } from 'src/app/app.component';
import { appConfig } from 'src/app/app.config';
import { armNativeSplashWatchdog, onBootstrapFailure } from 'src/app/core/helpers/splash.fallback';
import { environment } from 'src/environments/environment';
import { environments } from 'src/environments/environments';

// eslint-disable-next-line no-console
CapacitorUpdater.notifyAppReady().catch(err => console.error('@main:capgo: Failed to notify CapacitorUpdater that app is ready', err));

if (environment.name === environments.production || environment.name === environments.staging) {
  enableProdMode();
}

armNativeSplashWatchdog(); // the native splash must always come down, whatever fails below — see splash.fallback.ts
bootstrapApplication(AppComponent, appConfig).catch(onBootstrapFailure);
